// Tracks scan count + support-popup dismissal state in localStorage.
// localStorage can throw in private/incognito modes or when quota is exceeded;
// surface those errors to the console so they aren't silently swallowed.
const SCAN_KEY = "cveScanCount";
const DISMISS_KEY = "supportPopupDismissedAt";
const POPUP_TRIGGER = 3;          // show after this many scans
const DISMISS_COOLDOWN_DAYS = 14; // re-show after this many days if dismissed

export function bumpScanCount() {
  try {
    const cur = Number(localStorage.getItem(SCAN_KEY) || 0) + 1;
    localStorage.setItem(SCAN_KEY, String(cur));
    return cur;
  } catch (err) {
    console.warn("scanCounter: bump failed", err);
    return 0;
  }
}

export function getScanCount() {
  try {
    return Number(localStorage.getItem(SCAN_KEY) || 0);
  } catch (err) {
    console.warn("scanCounter: read failed", err);
    return 0;
  }
}

export function markDismissed() {
  try {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch (err) {
    console.warn("scanCounter: dismiss-mark failed", err);
  }
}

export function shouldShowSupportPopup() {
  const count = getScanCount();
  if (count < POPUP_TRIGGER) return false;
  try {
    const last = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (!last) return true;
    const ageDays = (Date.now() - last) / (1000 * 60 * 60 * 24);
    return ageDays > DISMISS_COOLDOWN_DAYS;
  } catch (err) {
    console.warn("scanCounter: dismiss-check failed", err);
    return true;
  }
}
